var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgU09 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 303.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-2862.00, 0.00)",
    id: "U9_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2869.58,235.44 C2871.03,228.07 2876.10,211.77 2879.12,204.78 C2882.16,197.80 2888.61,186.75 2893.81,179.47 C2898.20,173.57 2907.70,161.74 2912.81,155.80 C2918.17,149.85 2927.04,140.47 2934.95,132.96 C2946.50,122.36 2977.78,96.80 2986.50,91.09 C2993.35,86.64 3006.72,79.96 3013.24,77.74 C3016.49,76.64 3022.48,75.12 3026.08,74.46 C3029.37,73.89 3037.04,73.83 3040.73,74.20 C3044.51,74.60 3051.94,76.25 3055.59,77.49 C3062.88,80.03 3073.79,86.59 3083.64,94.00 C3090.05,98.98 3101.90,108.70 3107.33,113.44 C3114.67,120.13 3123.37,129.47 3127.18,134.10 C3131.54,139.42 3139.01,150.31 3141.21,154.97 C3144.05,161.11 3149.05,177.95 3151.26,188.85 C3152.78,196.44 3156.49,234.81 3157.60,252.15 C3159.17,290.19 3160.22,337.04 3160.36,350.34 C3160.41,356.94 3158.17,377.05 3156.73,382.03 C3155.98,384.52 3153.61,387.88 3151.16,389.80 C3146.13,393.66 3132.28,399.45 3123.80,402.05 C3114.31,404.78 3081.09,412.73 3063.09,416.51 C3053.89,418.27 3036.14,421.14 3027.60,422.24 C3019.28,423.13 3003.30,424.26 2995.65,424.50 C2986.52,424.60 2968.01,422.93 2958.90,421.19 C2949.81,419.43 2935.28,414.81 2926.11,410.84 C2919.36,407.85 2906.91,402.25 2901.20,399.63 C2892.44,395.43 2883.71,390.10 2879.58,385.31 C2878.16,383.62 2875.90,378.46 2874.74,374.76 C2872.87,368.65 2871.98,362.74 2871.75,360.37 C2870.58,347.03 2868.05,316.05 2866.69,298.42 C2866.26,289.17 2866.10,271.41 2866.49,263.01 C2866.94,254.68 2868.76,239.71 2869.58,235.44 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgU09, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/U-09.0169c196.svg";
export { ForwardRef as ReactComponent };